<template>
  <page-edicion :fluid="false">
    <page-header :title="oferta.descripcion" :subtitle="`${oferta.codigo} v${oferta.numeroVersion}`" @back="volver()" />

    <h3>Perder oferta</h3>

    <b-row>
      <b-col>
        <b-form-group label="Código">
          <b-form-input v-model="oferta.codigo" readonly />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Versión">
          <b-form-input v-model="oferta.numeroVersion" readonly />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group label="Unidad de negocio">
          <b-form-input v-model="unidadNegocio.nombreComercial" readonly />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Cliente">
          <b-form-input v-model="cliente.nombre" readonly />
        </b-form-group>
      </b-col>
    </b-row>

    <div>
      <b-form ref="form" @submit.prevent="submit">
        <b-form-group label="Fecha perdida">
          <b-form-datepicker v-model="perdidaEl" required />
        </b-form-group>

        <b-form-group label="Motivo">
          <b-form-select v-model="motivoCierreId" :options="motivosCierre" required />
        </b-form-group>

        <div class="text-right">
          <b-button variant="success" :disabled="!puedePerder" type="submit"> Perder Oferta </b-button>
          <b-button class="ml-2" @click="cancelar()"> Cancelar </b-button>
        </div>
      </b-form>
    </div>
  </page-edicion>
</template>

<script>
import { mapState } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import * as ofertasApi from "@/services/ofertas";

export default {
  computed: {
    ...mapState(useSessionStore, ["esAdmin"]),
    puedePerder() {
      return this.oferta.entregada && !this.oferta.perdida && !this.oferta.ganada;
    },
  },
  data() {
    return {
      perdidaEl: new Date(),
      oferta: {},
      cliente: {},
      ofertaBase: {},
      unidadNegocio: {},
      motivoCierreId: null,
      motivosCierre: [],
    };
  },
  methods: {
    cancelar() {
      this.volver();
    },
    volver() {
      this.$router.push("/ofertas");
    },
    async cargarOferta(id) {
      const data = await ofertasApi.cargarCompleta(id);
      this.oferta = data.oferta;
      this.cliente = data.cliente;
      this.ofertaBase = data.ofertaBase;
      this.unidadNegocio = data.unidadNegocio;
      this.clienteTieneDatosCompletos = data.clienteTieneDatosCompletos;

      const response = await this.$backend.get("/motivosCierreOferta/comboParaPerder");
      this.motivosCierre = response.data;
    },
    async submit() {
      if (this.perdidaEl == "") {
        return this.$messages.alert("Seleccione una fecha.");
      }

      await this.$backend.post("ofertas/perderVersion", {
        ofertaId: this.oferta.id,
        perdidaEl: this.perdidaEl,
        motivoCierreId: this.motivoCierreId,
      });

      this.$messages.success(`Oferta perdida: ${this.oferta.descripcion}`);
      this.volver();
    },
  },
  watch: {
    "$route.params": {
      handler() {
        this.cargarOferta(this.$route.params.id);
      },
      immediate: true,
    },
  },
};
</script>
